import React, { useEffect, useState } from 'react';
interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const targetDate = new Date('2026-01-06T19:00:00-05:00').getTime();
    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      if (distance < 0) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="flex flex-col items-center space-y-4 md:space-y-6 py-6 md:py-8" data-id="element-87">
      <h3 className="text-base sm:text-lg md:text-2xl font-bold text-red-500 px-4" data-id="element-88">
        La Masterclass Comienza En:
      </h3>
      <div className="flex gap-2 sm:gap-4 md:gap-8" data-id="element-89">
        <div className="flex flex-col items-center" data-id="element-90">
          <span className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black text-red-500" data-id="element-91">
            {String(timeLeft.days).padStart(2, '0')}
          </span>
          <span className="text-xs md:text-sm mt-1 md:mt-2 uppercase tracking-widest font-bold text-red-400" data-id="element-92">
            Días
          </span>
        </div>
        <div className="flex flex-col items-center" data-id="element-93">
          <span className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black text-red-500" data-id="element-94">
            {String(timeLeft.hours).padStart(2, '0')}
          </span>
          <span className="text-xs md:text-sm mt-1 md:mt-2 uppercase tracking-widest font-bold text-red-400" data-id="element-95">
            Horas
          </span>
        </div>
        <div className="flex flex-col items-center" data-id="element-96">
          <span className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black text-red-500" data-id="element-97">
            {String(timeLeft.minutes).padStart(2, '0')}
          </span>
          <span className="text-xs md:text-sm mt-1 md:mt-2 uppercase tracking-widest font-bold text-red-400" data-id="element-98">
            Min
          </span>
        </div>
        <div className="flex flex-col items-center" data-id="element-99">
          <span className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black text-red-500" data-id="element-100">
            {String(timeLeft.seconds).padStart(2, '0')}
          </span>
          <span className="text-xs md:text-sm mt-1 md:mt-2 uppercase tracking-widest font-bold text-red-400" data-id="element-101">
            Seg
          </span>
        </div>
      </div>
    </div>;
}